<template>
  <ais-menu :attribute="attribute" :limit="999">
    <template v-slot="{ items, refine }">
      <div class="dropdown-filter" v-if="items.length > 0">
        <span class="filter-name" v-show="labelVisible" v-html="attributeLabel"></span>
        <div class="dropdown" @click="onDropdownToggleClick($event)">
          <div class="btn btn-default dropdown-toggle" :id="[attribute + 'Dropdown']">
            <span class="choose-label" v-if="!items.filter((i) => i.isRefined).length">
              {{ 'Choose' | t }}
              {{ attributeLabel }}
            </span>
            <span class="active-value" v-else-if="getActiveValue(items)">
              <span class="active-value">
                <span class="remove-filter-value" @click="refine(getActiveValue(items).value)">×</span>
                {{ getActiveValue(items).label }}
              </span>
            </span>
            <span class="caret"></span>
            <ul class="dropdown-menu" :aria-labelledby="[attribute + 'Dropdown']">
              <li v-for="item in items" :key="item.value">
                <label :class="{ checked: item.isRefined }" @click.stop>
                  <input
                    type="checkbox"
                    class="sr-only"
                    v-model="item.isRefined"
                    @change="onChange($event, refine, item.value)"
                    :value="item.value"
                  />
                  {{ item.label }}
                </label>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>
  </ais-menu>
</template>

<script>
import $ from 'jquery';
import t from '../main/i18n';
import {getLangcode} from '../main/utils';

export default {
  name: 'DropdownFilter',
  props: {
    attribute: {
      type: String,
      required: true
    },
    attributeLabel: {
      type: String,
      required: true
    },
    labelVisible: {
      type: Boolean,
      default: true
    }
  },
  filters: {
    t
  },
  created() {
    document.documentElement.addEventListener('click', this.closeDropdowns);
  },
  beforeDestroy() {
    document.documentElement.removeEventListener('click', this.closeDropdowns);
  },
  computed: {
    langcode() {
      return getLangcode(this.$route.params.langcode);
    }
  },
  methods: {
    getActiveValue(items) {
      return items.find(i => i.isRefined);
    },
    onChange(event, refine, value) {
      const dropdown = event.target.closest('.dropdown');
      dropdown.classList.remove('open');
      refine(value);
    },
    onDropdownToggleClick(event) {
      if ($(event.target).hasClass('remove-filter-value')) {
        event.preventDefault();
      } else {
        document.querySelectorAll('.dropdown').forEach(dd => dd.classList.remove('open'));

        const $dropdown = $(event.target).closest('.dropdown');
        const open = $dropdown.hasClass('open');

        if (open) {
          $dropdown.removeClass('open');
        } else {
          $dropdown.addClass('open');
        }
      }
    },
    closeDropdowns(event) {
      const $dropdown = $(event.target).closest('.dropdown');
      if (!$dropdown.length) $('.dropdown').removeClass('open');
    }
  }
};
</script>
